/**
 * Permission Service
 * API calls for feature permission management
 */
import api from './api'

const permissionService = {
  /**
   * Get my access (for current user or guest)
   */
  async getMyAccess() {
    try {
      const response = await api.get('/permissions/my-access')
      return response.data
    } catch {
      return { status: 'success', data: { role: 'guest', allowed_features: [] } }
    }
  },

  /**
   * Check if current user has access to a feature
   */
  async checkPermission(featureKey) {
    try {
      const response = await api.get(`/permissions/check/${featureKey}`)
      return response.data
    } catch {
      return { status: 'error', data: { has_access: false } }
    }
  },

  // ============ Admin Methods ============

  /**
   * Get all permissions (admin only)
   */
  async getAllPermissions() {
    try {
      const response = await api.get('/permissions/admin')
      return response.data
    } catch {
      return { status: 'error', data: [] }
    }
  },

  /**
   * Create a new permission
   */
  async createPermission(data) {
    try {
      const response = await api.post('/permissions/admin', data)
      return response.data
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Có lỗi xảy ra'
      }
    }
  },

  /**
   * Update a permission
   */
  async updatePermission(id, data) {
    try {
      const response = await api.put(`/permissions/admin/${id}`, data)
      return response.data
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Có lỗi xảy ra'
      }
    }
  },

  /**
   * Delete a permission
   */
  async deletePermission(id) {
    try {
      const response = await api.delete(`/permissions/admin/${id}`)
      return response.data
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Có lỗi xảy ra'
      }
    }
  },

  /**
   * Bulk update permissions
   */
  async bulkUpdatePermissions(permissions) {
    try {
      const response = await api.put('/permissions/admin/bulk-update', { permissions })
      return response.data
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Có lỗi xảy ra'
      }
    }
  },

  /**
   * Initialize default permissions
   */
  async initDefaultPermissions() {
    try {
      const response = await api.post('/permissions/admin/init-defaults')
      return response.data
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Có lỗi xảy ra'
      }
    }
  },
}

export default permissionService
